import type { MoneyTotal, MovementKind } from '../model/period';

export const MOVEMENT_KINDS: MovementKind[] = ['ingreso', 'deducible', 'no_deducible'];

export const MOVEMENT_VISUALS: Record<MovementKind, { label: string; groupTitle: string; text: string; tile: string }> = {
	ingreso: { label: 'Ingresos', groupTitle: 'Ingresos', text: 'text-h-primary-50', tile: 'bg-h-primary-95' },
	deducible: { label: 'Deducibles', groupTitle: 'Gastos deducibles', text: 'text-h-success-50', tile: 'bg-h-success-95' },
	no_deducible: { label: 'No deducibles', groupTitle: 'Gastos no deducibles', text: 'text-h-error-50', tile: 'bg-h-error-95' },
};

export const NOT_COUNTED_TEXT = 'No suma a tu ingreso. En plataformas declaramos lo que reportan las apps en tus constancias de retenciones.';

export const NOT_COUNTED_CAPTION =
	'En plataformas declaramos lo que reportan las apps en tus constancias de retenciones, así que tus facturas no se suman a tu ingreso.';

export const expensesAmount = (totals: Record<MovementKind, MoneyTotal>) => totals.deducible.amount + totals.no_deducible.amount;
